module.exports = "<!-- <td> -->\n  <ng-content></ng-content>\n<!-- </td> -->\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/table/table-cell/table-cell.component.html
// module id = ../../../../../src/app/shared/components/table/table-cell/table-cell.component.html
// module chunks = 12